import React from 'react';
import WeeklySchedule from './WeeklySchedule';

function App() {
  return (
    <div className="App">
      <WeeklySchedule />
    </div>
  );
}

export default App;
